import React from 'react';

import {Grid, Header, Button, Segment, Checkbox} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {StatusIndicator} from 'app-ui-componentlibrary';
import {connect} from 'react-redux';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import {getTimestampNowISO} from 'common/utils';
import {isAOR} from 'go/security/permissions';

const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};
export class ReviewAndSubmitPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      acknowledged: false,
      openModal: MODALS.NONE,
    };
  }

  handleSubmit() {
    const {
      entityDataPath,
      entityType,
      fieldValue,
      fieldName,
      auth,
      submissionDataPaths,
    } = this.props;
    let loginName = auth.loginName;
    let currentTime = getTimestampNowISO();

    this.props.saveManyEntityData(submissionDataPaths, entityType, [
      loginName,
      currentTime,
      fieldValue,
    ]);
    this.setState({
      openModal: MODALS.CREATE,
    });
  }

  setAcknowledged = () => {
    if (isAOR(this.props.permissions)) {
      this.setState((prevState) => ({
        acknowledged: !prevState.acknowledged,
      }));
    }
  };

  renderSubmitSuccess() {
    return (
      <FemaGoModal
        title="Successfully Submitted"
        size="small"
        hideCancel={true}
        open={this.state.openModal === MODALS.CREATE}
        buttonText="Return to home page"
        confirmButton="hidden"
        cancelAction={() => this.setState({openModal: MODALS.NONE})}
      >
        <Alert
          size="medium"
          header=""
          content={this.props.alertContent}
          type="success"
          dismissable={false}
        />
        <a href={`/`} className="linkToHomePage" title="Return to home page">
          <Button primary> Return to home page</Button>
        </a>
      </FemaGoModal>
    );
  }

  render() {
    const {dynamicComponent, navToSpecificLocation} = this.props;
    const options = this.props.formOptions || {};
    const {noStyling} = options;
    var {acknowledged} = this.state;
    var isCheckboxEnable = true;
    var checkBoxCode = '';
    dynamicComponent.sectionsStatus.forEach((section) => {
      if (section.status === 'incomplete' || section.status === 'needsAttention')
        isCheckboxEnable = false;
    });
    if (isCheckboxEnable) {
      checkBoxCode = (
        <Checkbox
          label={this.props.checkBoxLabel}
          checked={acknowledged}
          enabled
          onChange={this.setAcknowledged}
        />
      );
    } else {
      checkBoxCode = (
        <Checkbox label={this.props.checkBoxLabel} checked={acknowledged} disabled />
      );
    }

    return (
      <Segment padded vertical={noStyling}>
        <React.Fragment>
          {this.props.title && <Header as="h1">{this.props.title}</Header>}
          {this.props.guidance && <p className="leadParagraph">{this.props.guidance}</p>}
          <div className="contents">
            <Grid divided="vertically">
              {_.map(dynamicComponent.sectionsStatus, (item, index) => {
                return item !== undefined && this ? (
                  <Grid.Row>
                    <Grid.Column Column width={1}>
                      <StatusIndicator status={item.status} />
                    </Grid.Column>
                    <Grid.Column Column width={4}>
                      {item.sectionName}
                    </Grid.Column>
                    <Grid.Column
                      floated="right"
                      width={2}
                      title={`Navigate to ${item.sectionName}`}
                    >
                      <a
                        onClick={() =>
                          navToSpecificLocation('contents[' + item.contentIndex + ']')
                        }
                        href={'#' + item.sectionName}
                      >
                        View/edit
                      </a>
                    </Grid.Column>
                  </Grid.Row>
                ) : (
                  ''
                );
              })}
              <Grid.Row />
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column width="10">{checkBoxCode}</Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width="10">
                  <Button
                    primary
                    disabled={!acknowledged}
                    onClick={() => this.handleSubmit()}
                  >
                    {this.props.submitButtonLabel}
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          {this.renderSubmitSuccess()}
        </React.Fragment>
      </Segment>
    );
  }
}

ReviewAndSubmitPanel.defaultProps = {
  isSubmittable: true,
};

export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
    data: state.dynamicComponent.data,
    context: state.dynamicComponent.context,
    jwt: state.auth.token,
    auth: state.auth,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps)(connectDynamic(ReviewAndSubmitPanel));
